<template>
  <div class="time-line" ref="timeLine" v-if="props.list.length > 0">
    <div class="list" v-for="(item, index) in props.list" :key="index">
      <div class="days">
        <div class="dot" :class="index === 0 ? 'dot-red' : ''"></div>
        <p ref="date" :class="index === 0 ? 'date-red' : 'date'">{{item.timeLineName}}</p>
      </div>
      <div class="null"></div>
      <div class="content-box" v-for="(value, i) in item.dataList" :key="i" @click="handleJumpDetail(value.jumpData)">
        <div class="content">
          <p class="text" v-if="value.contentType == 1"><span class="hot" :style="{color: value.tagVO.tagColor, backgroundColor: value.tagVO.tagBgColor}" v-if="value.tagVO && value.tagVO.tag">{{value.tagVO.tag}}</span>{{value.title}}</p>
          <p class="text" v-if="value.contentType == 0"><span class="hot" :style="{color: value.tagVO.tagColor, backgroundColor: value.tagVO.tagBgColor}" v-if="value.tagVO && value.tagVO.tag">{{value.tagVO.tag}}</span>{{value.content}}</p>
          <p class="text" v-if="value.contentType == 7"><span class="hot" :style="{color: value.tagVO.tagColor, backgroundColor: value.tagVO.tagBgColor}" v-if="value.tagVO && value.tagVO.tag">{{value.tagVO.tag}}</span>{{value.content}}</p>
          <img class="jump" src="~@/assets/jiantou@3x.png">
        </div>
      </div>
      <div :class="'items' + index"></div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref, toRefs, nextTick, watch } from 'vue';
import * as tools from '@/utils/utils';
import JUMP from '@/utils/jump'
import { List } from 'vant';
const props = defineProps({
  list: Array
})
const timeList = ref([]) // 获取时间线滚动list
const barHeihgt = ref(0);
// const abc = ref(null)
// watch(() => JSON.parse(JSON.stringify(props.list)), (newValue, oldValue) => {
//   console.log('watch 已触发新', newValue)
//   console.log('watch 已触发旧', oldValue)
//   console.log(newValue.length)
//   console.log(oldValue.length)
//   let newLength = newValue.length
//   let oldLength = oldValue.length
//   nextTick(() => {
//     timeList.value = []
//     props.list.map((res, i) => {
//       let topH = document.querySelector(`.items${i}`).getBoundingClientRect().top; // 获取每一项，底部距离文档顶部的距离
//       timeList.value.push(topH);
//     });
//     for (let i = oldLength + 1; i < newLength; i++) {
//       timeList.value.push(document.querySelector(`.items${i}`).getBoundingClientRect().top + timeList.value[0] + Math.abs(abc.value))
//     }
    
//     console.log(timeList.value)
//   })
// })

const getBarHeight = () => {
  if (tools.inJrApp()) {
    window.JrBridge.callNative(
      {
        type: "74",
      },
      (data) => {
        if (data && data.navBarTotalHeightDp) {
          barHeihgt.value = parseInt(data.navBarTotalHeightDp);
          
        }
      }
    );
  }
  init()
};
const init = () => {
  // timeList.value = []
  let timeHtml = document.getElementsByClassName('title-time')
  props.list.map((res, i) => {
    let topH = document.querySelector(`.items${i}`).getBoundingClientRect().top; // 获取每一项，底部距离文档顶部的距离
    timeList.value.push(topH);
  });
  // abc.value = timeList.value[0]
  console.log(timeList.value)
  timeHtml[0].innerHTML = props.list[0].timeLineName; // 默认展示第一项日期
}
const handleScroll = (e) => {
  // console.log(document.getElementsByClassName('date')[0])
  let scrollTop = window.pageYOffset + (100 + barHeihgt.value)
  let timeHtml = document.getElementsByClassName('title-time')
  timeList.value.map((res, i) => {
    if (scrollTop < timeList.value[0]) {
      timeHtml[0].innerHTML = props.list[0].timeLineName
      return
    }
    if (scrollTop >= timeList.value[i] && scrollTop < timeList.value[i + 1]) {
      timeHtml[0].innerHTML = props.list[i + 1].timeLineName;
    }
  })
  
}
const handleJumpDetail = (jumpData) => {
  JUMP(jumpData)
}
defineExpose({
  init
})
onMounted(() => {
  nextTick(() => {
    getBarHeight()
    window.addEventListener("scroll", handleScroll)
  })
});
</script>
<style>
.title-time {
  position: fixed;
  left: 0;
  width: 750px;
  height: 90px;
  padding: 23px 0 23px 24px;
  background: rgba(255,255,255,1);
  box-shadow:  0 2px 14px 0 rgba(0,0,0,0.08);
  z-index: 333;
}
</style>
<style lang='scss' scoped>
  .time-line {
    width: 702px;
    margin: 0 auto;
    background: #FFFFFF;
    padding: 28px 17px 28px 33px;
    margin-bottom: 30px;
    position: relative;
    
    .list {
      position: relative;
      .days {
        display: flex;
        align-items: center;
        .dot {
          width: 14px;
          height: 14px;
          background: rgba(102,102,102,1);
          border-radius: 50%;
          z-index: 2;
        }
        .dot-red {
          background: linear-gradient(rgba(255,46,46,1), rgba(255,46,46,1)),linear-gradient(rgba(102,102,102,1), rgba(102,102,102,1));
        }
        .date, .date-red {
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(51,51,51,1);
          margin-left: 26px;
          position: sticky;
          top: 0;
        }
        
        .date-red {
          color: rgba(239,64,52,1);
        }
        
        .date-s {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: normal;
          color: rgba(153,153,153,1);
          padding-left: 8px;
          padding-bottom: 6px;
        }
      }
      .null {
        width: 100%;
        height: 42px;
      }
      .content-box {
        width: 100%;
        padding-bottom: 30px;
        max-height: 154px;
      }
      .content {
        width: 628px;
        max-height: 124px;
        background: rgba(244,245,247,.6);
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding: 12px 13px 12px 17px;
        margin-left: 24px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(51,51,51,1);
        position: relative;
        .hot {
          min-width: 68px;
          height: 32px;
          border-radius: 4px;
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 500;
          line-height: 32px;
          text-align: center;
          margin-right: 5px;
          padding: 1px 12px;
        }
        .text {
          max-width: 488px;
          display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
          -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
          -webkit-line-clamp: 2; /* 2行，只有 webkit内核支持 */
          word-break: break-all; /* 纯英文换行 */
          overflow: hidden;
        }
        .jump {
          width: 26px;
          height: 26px;
          position: absolute;
          right: 13px;
          top: 21px;
        }
      }
      .content-box::before {
        content: "";
        position: absolute;
        left: 6px;
        top: 28px;
        width: 0;
        height: 100%;
        display: block;
        border-left: 1px dashed #ddd;
      }
    }
    
  }
</style>
